import { NgModule } from '@angular/core';
import { PolicyEnforcementComponent } from '@app/authorized/policyEngine/policy-enforcement/policy-enforcement.component';
import { EnforcementComponent } from '@app/authorized/policyEngine/policy-enforcement/enforcement/enforcement.component';
import { SharedModule } from '@app/shared';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';

@NgModule({
    imports: [SharedModule, MatTableModule, MatSortModule],
    declarations: [
        PolicyEnforcementComponent,
        EnforcementComponent
    ],
    entryComponents: [PolicyEnforcementComponent],
    exports: [PolicyEnforcementComponent]
})
export class PolicyEnforcementModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/policy-enforcement/policy-enforcement.module.ts